<template>
    <!-- 导入 -->
    <el-dialog :title="title" :visible.sync="dialogVizible" :close-on-click-modal="false"   v-loading="true" custom-class="form-dialog"
        width="70%" @close='closeExportDialog()'>
        <div class="mg-btm20" v-if="exportDialog.tableData.failRes">
            <div class="d-flex mg-btm10" style="align-items: flex-end">
                <div class="mg-rgt10">
                    <i class="el-icon-warning" style="color:#fa4031;font-size: 60px;"
                        v-if="exportDialog.tableData.failCnt > 0"></i>
                    <i class="el-icon-success" v-else style="color:#00ff00;font-size: 60px;"></i>
                </div>
                <div :class="[exportDialog.tableData.failCnt > 0 ? 'col-f41' : 'col-0f0', 'fz18']">
                    {{ exportDialog.tableData.failCnt > 0 ? '上传失败！' : '上传成功！' }}
                </div>
            </div>
            <div class="d-flex flex-align-center">
                <div class="fz14">正确：<span class="col-0f0">{{ exportDialog.tableData.total -
                    exportDialog.tableData.failCnt
                }}</span></div>
                <div class="fz14 mg-lef20">错误：<span class="col-f41">{{ exportDialog.tableData.failCnt }}</span></div>
            </div>
            <el-table :data="exportDialog.tableData.failRes" style="width: 100%" :height="500">
                <el-table-column v-for="(item, index) in exportDialog.headerList" :key="index" :prop="item.prop"
                    :label="item.label">
                    <template #default="scope">
                        <div v-if="item.prop === 'row'">{{ scope.$index + 1 }}</div>
                        <div v-if="item.prop === 'failRow'">第{{ scope.row.failRow }}行</div>
                        <div v-if="item.prop === 'failMsg'">{{ scope.row.failMsg }}</div>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="d-flex" >
            <div class="mg-tp5">上传文件：</div>
            &nbsp;&nbsp; <my-upload :fileList="exportUploadProperty.config.yourValue" v-bind="exportUploadProperty"
                @upload-success="handleSuccessExport" @beforeUpload="beforeUploadExport"
                @upload-remove="handleRemoveExport">
                <el-button size="small" type="primary" plain>导入</el-button>
                <div slot="tip">请上传.xls、.xlsx 文件</div>
            </my-upload>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" class="title" @click="dialogVizible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import MyUpload from "@/components/myUpload.vue";

export default {
    components: {
        MyUpload
    },
    props: {
        exportUploadProperty: {
            type: Object,
            default: () => {
                return {
                    config: {
                        customAction: "", // 替换成你的上传地址
                        accept: '.xls,.xlsx',
                        headers: {
                        },
                        disabled: false,
                        limit: 1,
                        uploadData: {
                            // 可选的上传数据
                        },
                        yourValue: [], // 双向绑定的值
                    },
                }
            }
        },
        visible: {
            type: Boolean,
            default: false
        },
        fileSize: {
            type: Number,
            default: 100
        },
        title: {
            type: String,
            default: '导入'
        },
        getResult: { type: Function }

    },
    watch: {
        visible (val) {
            this.dialogVizible = val
        }
    },
    data () {
        return {
            dialogVizible: this.visible,
            exportDialog: {
                title: '导入',
                visible: false,
                tableData: { total: 0, failCnt: 0 },
                headerList: [
                    { label: '序号', prop: 'row' },
                    { label: '位置', prop: 'failRow' },
                    { label: '失败原因', prop: 'failMsg' }
                ]
            }
        }
    },
    methods: {
        closeExportDialog () {
            this.exportUploadProperty.config.yourValue = [];
            this.exportDialog.tableData = { total: 0, failCnt: 0 };
            this.$emit('close')
        },
        beforeUploadExport (rawFile, fun) {
            const get = _ => {
                const fileExtensions = this.exportUploadProperty.config.accept;
                // 使用 split 方法将字符串分割成数组，然后使用 map 方法去掉点号
                const extensionsArray = fileExtensions.split(',').map(extension => extension.replace('.', ''));
                const containsExtension = extensionsArray.some(extension => rawFile.name.toLowerCase().endsWith(extension.toLowerCase()));
                if (!containsExtension) {
                    this.$store.state.loading = false;
                    this.$message({ message: '请上传正确的格式！', type: 'error' })
                    return false;
                } else if (rawFile.size / 1024 / 1024 > this.fileSize) {
                    this.$store.state.loading = false;
                    this.$message({ message: `超过${this.fileSize}上传大小！`, type: 'error' })
                    return false;
                }
                return true;
            };
            fun(get());
        },
        handleSuccessExport (data, file) {
            this.$store.state.importLoading = true;
            const interval = setInterval(async _ => {
                const res = await this.getResult();
                if (res.data.status === 2) {
                    this.$store.state.importLoading = false;
                    this.exportDialog.tableData = res.data;
                    clearInterval(interval);
                }
            }, 2000);
        },
        handleRemoveExport (file, fileList) {
            this.exportUploadProperty.config.yourValue = [];
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/myImportDialog.vue